// Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {StripeProductTier} from '../../../types/subscription';
import {FormBuilder, FormGroup} from '@angular/forms';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

@Component({
    selector: 'app-edit-exp-date',
    templateUrl: './edit-exp-date.component.html',
    styleUrls: ['./edit-exp-date.component.scss'],
    standalone: false
})
export class EditExpDateComponent {
  formGroup: FormGroup;
  fHeader: string;
  fSubEnd: string;
  fCancel: string;
  fSave: string;
  fDelay: string;
  fDuration: string;
  notifyAdminsByEmail: boolean;
  selectedLanguage: string;
  invalidExpiration = false;
  invalidDelay = false;
  selectedSubType = null;

  constructor(
    public readonly dialogRef: MatDialogRef<EditExpDateComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly translate: TranslateService,
    private readonly formBuilder: FormBuilder,
  ) {
    this.translate.get(['EE_HEADER', 'EE_SUB_END', 'CANCEL_CAP', 'SAVE_CAP', 'ADO_DELAY', 'ADO_DURATION']).subscribe(vals => {
      this.fHeader = vals['EE_HEADER'];
      this.fSubEnd = vals['EE_SUB_END'];
      this.fCancel = vals['CANCEL_CAP'];
      this.fSave = vals['SAVE_CAP'];
      this.fDelay = vals['ADO_DELAY'];
      this.fDuration = vals['ADO_DURATION'];
    });
    this.notifyAdminsByEmail = false;
    this.selectedLanguage = localStorage.getItem('language') || 'en';
    if ( data.subType !== undefined ) {
      this.selectedSubType = data.subType;
    }
    this.formGroup = this.formBuilder.group({
      expirationDate: [dayjs.utc(data.date).toDate()],
      maintenance_end: [dayjs.utc(data.maintDate).toDate()],
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSubmit() {
    const result = { ...this.data,
      notify: this.notifyAdminsByEmail,
      date: this.formGroup.value['expirationDate'],
      maintDate: this.formGroup.value['maintenance_end'],
      notifyLanguage: this.selectedLanguage,
      selectedSubType: this.selectedSubType };
    this.dialogRef.close(result);
  }

  onLanguageChanged(language) {
    this.selectedLanguage = language;
  }

  onNotifyCheckChanged(event) {
    this.notifyAdminsByEmail = (event && event.checked) || false;
  }

  protected readonly StripeProductTier = StripeProductTier;
}
